import React from 'react';

const Card = ({
  children,
  variant = 'default',
  hover = false,
  onClick,
  className = '',
  padding = 'default',
}) => {
  const variantClasses = {
    default: 'card',
    flat: 'card-flat',
    hover: 'card-hover',
  };

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
  };

  const baseClasses = hover ? variantClasses.hover : variantClasses[variant];
  const interactiveClasses = onClick ? 'cursor-pointer' : '';

  return (
    <div
      className={`${baseClasses} ${paddingClasses[padding]} ${interactiveClasses} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyPress={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onClick(e);
              }
            }
          : undefined
      }
    >
      {children}
    </div>
  );
};

export default Card;
